import moment from 'moment';

export type FormKeys<T> = keyof T;

export const getChangedFields = <T extends Record<string, any>>(
    currentData: T,
    initialData: Partial<T>,
    formKeys: FormKeys<T>[]
): Partial<T> => {
    const changedFields: Partial<T> = {};

    formKeys.forEach(key => {
        if (currentData[key] !== initialData[key]) {
            changedFields[key] = currentData[key];
        }
    });

    return changedFields;
};

export const formatDate = (value: number | undefined, format: string = 'YYYY.MM.DD') => {
    if (!value) {
        return '-';
    }
    return moment(value).format(format);
};

export const deleteUndefinedProperty = (query: any) => {
    Object.keys(query).forEach(
        key => (query[key] === undefined || query[key] === '' || query[key] === null) && delete query[key]
    );
    return query;
};
